// extracted by mini-css-extract-plugin
export var csatScore = "_kd-5";
export var header = "_kd-1";
export var panelWrapper = "_kd-2";
export var postPreview = "_kd-3";
export var rightContent = "_kd-0";
export var wrappingText = "_kd-4";